import React from 'react';
import {Link} from 'react-router-dom';
import './Landing.css';

const Landing=()=>{
return(
	<main>
		<div><Link to="portfolio/App">Simple portflio. (Use of react-router & portals)</Link></div>
		<div><Link to="image/App">Image search app. (API request using axios)</Link></div>		
	    <div><Link to="hemisphere/App">Hemisphere app. (geolocation based)</Link></div>
	</main>
)
}
export default Landing;